<template>
  <div
    class="flex items-end border-b-2 lg:border-b-2px h-full"
    :class="{
      'border-color-regular': lightTheme,
      'border-interaction-light text-interaction-light': !lightTheme
    }"
    v-show="search !== ''"
  >
    <div
      class="h-full flex flex-col justify-end cursor-pointer"
      @click="clearSearch"
    >
      <button
        class="flex-shrink-0 border-transparent hover:text-gray-600 -mb-1"
        type="button"
      >
        X
      </button>
    </div>
    <div
      class="h-full flex flex-col justify-end cursor-pointer"
      @click="showSearch"
    >
      <span
        class="px-2 h-6 w-64 text-center italic text-chplus-s -mb-1"
        :class="{ 'text-color-regular': lightTheme, 'text-white': !lightTheme }"
        >{{ search }}</span
      >
    </div>
  </div>
</template>

<script>
import Vue from "vue";

export default {
  name: "SearchDisplay",
  props: {
    initialSearch: {
      type: String,
      default: ""
    },
    lightTheme: {
      type: Boolean,
      default: false
    },
    /**
     * @description Used for communication with SortingButtons and SortingButtonOverlays component.
     */
    sortingBus: {
      type: Vue,
      required: true
    }
  },
  data: () => {
    return {
      search: ""
    };
  },
  created() {
    this.search = this.initialSearch;
    this.sortingBus.$on("search", this.onSearch);
  },
  methods: {
    showSearch() {
      this.sortingBus.$emit("showSearch", this.search);
    },
    clearSearch() {
      this.sortingBus.$emit("search", "");
    },
    onSearch(search) {
      this.search = search;
    }
  }
};
</script>
